export default "__VITE_ASSET__491f5ccc__"